/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the BookingPublic interface.
 */
export function instanceOfBookingPublic(value) {
    if ((!('adReportingId' in value) && !('AdReportingId' in value)) || (value['adReportingId'] === undefined && value['AdReportingId'] === undefined))
        return false;
    return true;
}
export function BookingPublicFromJSON(json) {
    return BookingPublicFromJSONTyped(json, false);
}
export function BookingPublicFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'name': json['Name'] == null ? undefined : json['Name'],
        'refSlot': json['RefSlot'] == null ? undefined : json['RefSlot'],
        'adReportingId': json['AdReportingId'],
        'assetId': json['AssetId'] == null ? undefined : json['AssetId'],
        'selected': json['Selected'] == null ? undefined : json['Selected'],
        'assetUrl': json['AssetUrl'] == null ? undefined : json['AssetUrl'],
        'assetText': json['AssetText'] == null ? undefined : json['AssetText'],
        'assetEffectConfig': json['AssetEffectConfig'] == null ? undefined : json['AssetEffectConfig'],
    };
}
export function BookingPublicToJSON(json) {
    return BookingPublicToJSONTyped(json, false);
}
export function BookingPublicToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Name': value['name'],
        'RefSlot': value['refSlot'],
        'AdReportingId': value['adReportingId'],
        'AssetId': value['assetId'],
        'Selected': value['selected'],
        'AssetUrl': value['assetUrl'],
        'AssetText': value['assetText'],
        'AssetEffectConfig': value['assetEffectConfig'],
    };
}
